import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { type ReactNode, startTransition } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { BrandXXS } from 'atoms/typography';
import type { unitMapping } from 'lib/style';

const BreadcrumbWrapper = styled(Horizontal)`
  width: fit-content;
  flex-wrap: wrap;
  &.withPadding {
    padding: var(--double-unit);
  }
`;

const StyledLink = styled(Link)<{ disabled: boolean }>`
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

type Section = {
  name: ReactNode;
  to?: string;
};

type Props = {
  sections?: Section[];
  gap?: keyof typeof unitMapping;
  withPadding?: boolean;
};

export const Breadcrumb = ({
  sections,
  gap = 2,
  withPadding = false,
}: Props) => {
  const navigate = useNavigate();
  return (
    <BreadcrumbWrapper gap={gap} className={classNames({ withPadding })}>
      {sections?.map((section, index) => (
        <StyledLink
          key={section.name?.toString()}
          to={section.to ?? ''}
          disabled={index === sections.length - 1}
          onClick={e => {
            e.preventDefault();
            startTransition(() => {
              navigate(section.to ?? '');
            });
          }}
        >
          <Horizontal gap={gap}>
            {index !== 0 && <FontAwesomeIcon icon={faChevronRight} size="xs" />}
            <BrandXXS>{section.name}</BrandXXS>
          </Horizontal>
        </StyledLink>
      ))}
    </BreadcrumbWrapper>
  );
};
